import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["flash"];

  /**
   * Rails UJS ajax:success after PATCH toggle. Response is order_row_toggle_response:
   * flash wrapper + table-wrapped <tr> (valid HTML for DOMParser).
   */
  toggleSuccess(event) {
    const [_data, _status, xhr] = event.detail;
    const doc = new DOMParser().parseFromString(xhr.response, "text/html");

    if (this.hasFlashTarget) {
      const flashEl = doc.querySelector(
        '[data-toggle-orders-target="flash"]'
      );
      if (flashEl) {
        this.flashTarget.innerHTML = flashEl.innerHTML;
      }
    }

    const newRow =
      doc.querySelector('tr[id^="row-"]') || doc.querySelector("tr[id]");
    if (!newRow) return;

    const existing = document.getElementById(newRow.id);
    if (!existing) return;

    existing.outerHTML = newRow.outerHTML;

    const orderId = newRow.id.replace(/^row-/, "");
    const newModal = doc.getElementById(`mobileActionsModal-${orderId}`);
    const oldModal = document.getElementById(`mobileActionsModal-${orderId}`);
    if (newModal && oldModal) {
      oldModal.outerHTML = newModal.outerHTML;
    }
  }

  /** Assign-staff form success: same row/mobile-modal swap, then close the shared ajax modal. */
  assignSuccess(event) {
    this.toggleSuccess(event);
    const ajaxModal = document.getElementById("ajaxModal");
    if (ajaxModal) {
      bootstrap.Modal.getInstance(ajaxModal)?.hide();
    }
  }

  /** Toggle PATCH failed — replace row cells with error response (same as former ajax-form on tr). */
  toggleError(event) {
    const [_data, _status, xhr] = event.detail;
    const row = event.currentTarget.closest('tr[id^="row-"]');
    if (!row || !xhr.response) return;
    row.innerHTML = xhr.response;
  }
}
